// <copyright file="eventBus.ts">
// �2016-2021 Audio Visual Preservation Solutions, Inc.
// <date>9/13/21 2:32:18 PM</date>
// </copyright>

import Vue from 'vue';
const eventBus = new Vue();
export default eventBus;
